/* -------------------------------------------------------------
■「販売店名」の設定
例）var HANBAITEN_NAME = "販売店名";
------------------------------------------------------------- */
var HANBAITEN_NAME = "株式会社エイト";

/* -------------------------------------------------------------
■「戻るボタン遷移先」の設定
例）var BACK_URL = "販売店ページへ戻る遷移先URL";
------------------------------------------------------------- */
var BACK_URL = "https://www.aplus.co.jp/";

/* -------------------------------------------------------------
■「月々の返済金最少額」の設定
例）var MIN_PAY_MONTH = new Number( 月々の返済金最少額 )
------------------------------------------------------------- */
var MIN_PAY_MONTH = new Number(3000) ;

/* -------------------------------------------------------------
■「月々の返済金最少額アラート」を表示するか否かの設定
例）表示する場合
	MIN_PAY_MONTH_ALERT = true ;
	表示しない場合
	MIN_PAY_MONTH_ALERT = false ;
------------------------------------------------------------- */
var MIN_PAY_MONTH_ALERT = true ;

/* -------------------------------------------------------------
■「実質年率」の設定
例）LoanSimulation.NENRITSU = new Number( 実質年率 ) ;
------------------------------------------------------------- */
LoanSimulation.NENRITSU = new Number() ;

/* -------------------------------------------------------------
■「分割回数」の設定
例）LoanSimulation.MAX_OF_PAY_TIMES = new Number( 分割回数 ) ;
------------------------------------------------------------- */
LoanSimulation.MAX_OF_PAY_TIMES = new Number(120) ;

/* -------------------------------------------------------------
■「実質年率」を表示するか否かの設定
例）表示する場合
	LoanSimulation.RATE_VISIBILITY = true ;
	表示しない場合
	LoanSimulation.RATE_VISIBILITY = false ;
------------------------------------------------------------- */
LoanSimulation.RATE_VISIBILITY = false ; 

/* -------------------------------------------------------------
■「支払回数」と「分割払手数料」の設定
例）ENTRY[ ENTRY.length ] = new LoanSimulation( 支払回数, 手数料の額 ) ;
------------------------------------------------------------- */
var ENTRY = new Array( ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation(  3, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation(  6, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 10, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 12, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 18, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 20, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 24, 0.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 30, 0.96 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 36, 1.68 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 42, 2.40 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 48, 3.12 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 54, 3.84 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 60, 4.56 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 66, 5.28 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 72, 6.00 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 78, 6.72 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 84, 7.44 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 90, 8.16 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 96, 8.88 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 100, 9.36 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 102, 9.60 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 108, 10.32 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 114, 11.04 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 120, 11.76 ) ;

